import router from "@/router";
// eslint-disable-next-line object-curly-newline
import {
  reactive,
  getCurrentInstance,
  watch,
  toRefs,
} from "@vue/composition-api";

export const isObject = (obj) => typeof obj === "object" && obj !== null;

export const isToday = (date) => {
  const today = new Date();
  return (
    /* eslint-disable operator-linebreak */
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
    /* eslint-enable */
  );
};

const getRandomFromArray = (array) =>
  array[Math.floor(Math.random() * array.length)];

// ? Light and Dark variant is not included
// prettier-ignore
export const getRandomBsVariant = () => getRandomFromArray(['primary', 'secondary', 'success', 'warning', 'danger', 'info'])

export const isDynamicRouteActive = (route) => {
  const { route: resolvedRoute } = router.resolve(route);
  return resolvedRoute.path === router.currentRoute.path;
};

// Thanks: https://medium.com/better-programming/reactive-vue-routes-with-the-composition-api-18c1abd878d1
export const useRouter = () => {
  const vm = getCurrentInstance().proxy;
  const state = reactive({
    route: vm.$route,
  });

  watch(
    () => vm.$route,
    (r) => {
      state.route = r;
    },
  );

  return { ...toRefs(state), router: vm.$router };
};

export function getParams(arrayParams = []) {
  const searchParams = new URLSearchParams();
  const arr = Array.isArray(arrayParams) ? arrayParams : [];
  arr.forEach((param) => {
    const split = param.split(",");
    if (split.length === 2) {
      searchParams.append(split[0].trim(), split[1].trim());
    }
  });
  return searchParams;
}

export function getParamsAll(arrayParams = []) {
  const searchParams = new URLSearchParams();
  const arr = Array.isArray(arrayParams) ? arrayParams : [];

  arr.forEach((param) => {
    const index = param.indexOf(","); // Encuentra la primera coma que separa key y value
    if (index !== -1) {
      const key = param.slice(0, index).trim(); // Extrae la clave
      const value = param.slice(index + 1).trim(); // Extrae el valor, incluyendo comas en el valor
      searchParams.append(key, value);
    }
  });

  return searchParams;
}

export function showLoading() {
  const appLoading = document.getElementById("loading-bg");
  appLoading.style.display = "block";
}

export function stopLoading() {
  const appLoading = document.getElementById("loading-bg");
  appLoading.style.display = "none";
}

// export const decimalNumberFormat = (amounth) => {
//   let commaRegex = /,/;

//   if (amounth == 0) {
//     return amounth;
//   } else if (amounth == 0.0) {
//     return amounth;
//   } else if (commaRegex.test(amounth)) {
//     const newAmounth = amounth.replace(/,/g, "");

//     return newAmounth;
//   } else {
//     return amounth;
//   }
// };

export const extension = (url) => {
  const partes = url.split(".");
  if (partes.length > 1) {
    return partes.pop();
  }

  return null;
};

export const extensionValidaPreview = (url) => {
  const partes = url.split(".");
  if (partes.length > 1) {
    let extension = partes[1];

    if (
      extension === "jpg" ||
      extension === "png" ||
      extension === "pdf" ||
      extension === "PDF" ||
      extension === "JPG" ||
      extension === "JPEG" ||
      extension === "jpeg"
    )
      return true;
    else return false;
  } else {
    return false;
  }
};

export const validarNombreArchivo = (fileName) => {
  const invalidCharacters = /[\\/#?%*:|"<>¦`~]/;

  const isInvalid =
    invalidCharacters.test(fileName) ||
    fileName.startsWith(".") ||
    fileName.endsWith(".") ||
    fileName.trim() !== fileName ||
    fileName.length > 1024;

  return !isInvalid;
};

export const decimalNumberFormat = (amount) => {
  // Si el amount es 0 o 0.0, simplemente retorna el valor
  if (amount === 0 || amount === 0.0) {
    return amount;
  }

  // Reemplaza las comas y retorna el nuevo valor
  return amount.toString().replace(/,/g, "");
};
export const getUser = () => {
  let sesionData = JSON.parse(localStorage.getItem("session"));
  return sesionData.appConfig;
};

export const isValidUrl = (url) => {
  if (!url || url.trim() === "") {
    return true;
  } else {
    const urlRegex =
      /^(https?|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]*[-A-Za-z0-9+&@#/%=~_|]$/;
    return urlRegex.test(url);
  }
};
/**
 * This is just enhancement over Object.extend [Gives deep extend]
 * @param {target} a Object which contains values to be overridden
 * @param {source} b Object which contains values to override
 */
// export const objectExtend = (a, b) => {
//   // Don't touch 'null' or 'undefined' objects.
//   if (a == null || b == null) {
//     return a
//   }

//   Object.keys(b).forEach(key => {
//     if (Object.prototype.toString.call(b[key]) === '[object Object]') {
//       if (Object.prototype.toString.call(a[key]) !== '[object Object]') {
//         // eslint-disable-next-line no-param-reassign
//         a[key] = b[key]
//       } else {
//         // eslint-disable-next-line no-param-reassign
//         a[key] = objectExtend(a[key], b[key])
//       }
//     } else {
//       // eslint-disable-next-line no-param-reassign
//       a[key] = b[key]
//     }
//   })

//   return a
// }
